export const deClientPortalAssetPageLayout = {
    sectionLabel: 'IMMOBILIE',
}
